module.exports = __webpack_public_path__ + "img/area_2.c3e1cf4d.png";